import index from "./editorBlank.vue";
export default index;
